import * as Yup from 'yup';
import { TemplateFormSSLConfigField } from '../TemplateFormSSLConfigField';
import { TemplateFormSslConfigFieldMeta } from '../interfaces/template-form-ssl-config-field-meta';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';

const SSL_CLIENT_KEY_CERT_FILE_ERROR =
  'Both Client Key and Client Certificate are required fields if one is provided';

export const SSLFieldMeta: TemplateFormComponentMeta<TemplateFormSslConfigFieldMeta> = {
  component: TemplateFormSSLConfigField,
  MetadataFactory: (field, disableEdit) => ({
    disabled: disableEdit || !!field.disabled
  }),
  ValidationSchemaFactory: field =>
    Yup.object().shape({
      [field.name]: Yup.boolean().nullable(),
      ssl_ca_file: Yup.string().when([field.name], (sslEnabled, schema) => {
        return sslEnabled ? schema.required('CA file is required field') : schema.nullable();
      }),
      ssl_client_key: Yup.string()
        .nullable()
        .test({
          name: 'ssl-client-key-cert',
          message: SSL_CLIENT_KEY_CERT_FILE_ERROR,
          test(value) {
            const { ssl_client_cert_file: sslClientCertFile, [field.name]: sslEnabled } =
              this.parent;

            if (!sslEnabled) {
              return true;
            }

            return !((value && !sslClientCertFile) || (!value && sslClientCertFile));
          }
        }),
      ssl_client_cert_file: Yup.string()
        .nullable()
        .test({
          name: 'ssl-client-cert-key',
          message: SSL_CLIENT_KEY_CERT_FILE_ERROR,
          test(value) {
            const { ssl_client_key: sslClientKey, [field.name]: sslEnabled } = this.parent;

            if (!sslEnabled) {
              return true;
            }

            return !((value && !sslClientKey) || (!value && sslClientKey));
          }
        })
    })
};
